module.exports = __webpack_public_path__ + "Frame417-1abe050b.webp";